var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { dsvFormat } from "d3-dsv";
import { DataImportError, RadarError } from "../Errors.js";
import { RadarDataSource } from "./RadarDataSource.js";
/**
 *
 *
 * @export
 * @class DsvDataSource
 * @extends {RadarDataSource}
 */
export class DsvDataSource extends RadarDataSource {
    constructor(fileURIs, delimiter = ",") {
        super();
        this.fileURIs = fileURIs;
        this.delimiter = delimiter;
    }
    fetchData() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const [_slices, _subSlices, _rings, _items] = yield Promise.all([
                    this.fetchCsvContent(this.fileURIs.slices),
                    this.fetchCsvContent(this.fileURIs.subSlices),
                    this.fetchCsvContent(this.fileURIs.rings),
                    this.fetchCsvContent(this.fileURIs.items),
                ]);
                const inputData = {
                    slices: _slices.map((slice) => Object.assign(slice, { subSlices: _subSlices.filter((subSlice) => subSlice.sliceId == slice.id) })),
                    rings: _rings,
                    items: _items,
                };
                this.setRadarContent(inputData);
                return inputData;
            }
            catch (error) {
                if (error instanceof RadarError)
                    throw error;
                throw new DataImportError(error);
            }
        });
    }
    fetchCsvContent(uri) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(uri);
            if (!response.ok) {
                throw "Can't get file: " + uri + "\nRequest status: " + response.status + " " + response.statusText;
            }
            const content = yield response.text();
            const parsedContent = dsvFormat(",").parse(content);
            return parsedContent;
        });
    }
}
//# sourceMappingURL=DsvDataSource.js.map